import { ref, type Ref } from "vue";
import type FormCC from "@/interface/FormCC";
import MasterService from "@/service/restfulService/CCOnboardMasterService";

export default function temrsConditionSubmit(
  ccFormValue: Ref<FormCC>,
  prop: any,
  page13Overlay: Ref<boolean>,
  isTimeOut: Ref<boolean>,
  isSessionEnd: Ref<boolean>,
  termsSubmitFail: Ref<boolean>,
  creditLimit: Ref<string>,
  count: Ref<number>,
  jumpStep: (value: number, name: string, page: string) => void
): void {
  isTimeOut.value = false;
  const requestModel = {
    dropOffStep: "S98",
    webFormRequestId: ccFormValue.value.webFormRequestId,
    cardId: prop.cardId,
    icNumber: ccFormValue.value.basicInformation.idNo,
    webFormDetails: {
      terms: {
        promotionFlag:
          ccFormValue.value.declaration.declaration4 == "true" ? "Y" : "N",
        taxpayerFlag:
          ccFormValue.value.declaration.declaration5 == "true" ? "Y" : "N",
        taxIdentificationNo:
          ccFormValue.value.declaration.declaration5 == "true"
            ? ccFormValue.value.declaration.taxpayer
            : "",
      },
    },
  };

  page13Overlay.value = true;
  MasterService.pageSubmit(requestModel, ccFormValue.value.token)
    .then((res) => {
      if (res.status == 200) {
        page13Overlay.value = true;
        termsSubmitFail.value = false;
        const requestModel2 = {
          webFormRequestId: ccFormValue.value.webFormRequestId,
          dsrBurst: ccFormValue.value.dsrBurst,
          resumeBy: prop.resumedByRecruiterId,
          resumedStaffName: prop.resumedByRecruiterName,
        };
        if (
          ccFormValue.value.basicInformation.idType == "0" &&
          ((ccFormValue.value.ekyc.status == "COMPLETE" &&
            ccFormValue.value.ekyc.preStatus == "") ||
            ccFormValue.value.ekyc.preStatus == "TIMEOUT" ||
            ccFormValue.value.ekyc.preStatus == "DOWN")
        ) {
          const requestModelPreAssessment = {
            webFormRequestId: ccFormValue.value.webFormRequestId,
            name: ccFormValue.value.basicInformation.name,
            icNo: ccFormValue.value.basicInformation.idNo,
            dateOfBirth: ccFormValue.value.basicInformation.dob,
            cardBusinessCode: prop.cardId,
            nationalityCode: ccFormValue.value.basicInformation.nationality,
            phoneNo:
              ccFormValue.value.basicInformation.countryCode +
              ccFormValue.value.basicInformation.mobileNo,
            grossIncome:
              ccFormValue.value.basicInformation.grossSalary.toString(),
            netIncome: ccFormValue.value.basicInformation.netSalary.toString(),
            refNo: ccFormValue.value.refNo,
          };
          MasterService.preAssesment(
            requestModelPreAssessment,
            ccFormValue.value.token
          )
            .then((res) => {
              if (res.status == 200) {
                // page3Overlay.value = false;
                ccFormValue.value.preAss.webFormRequestId =
                  res.data.responseModel.webFormRequestId;
                ccFormValue.value.dsrBurst = res.data.responseModel.dSRStatus;
                ccFormValue.value.dropOffStep = 13;
                creditLimit.value = res.data.responseModel.preAssessLimit;
                ccFormValue.value.ctosScore = res.data.responseModel.ctosScore;
                if (res.data.responseModel.preAssessStatus == "DECLINED") {
                  page13Overlay.value = false;
                  jumpStep(14, "denied2", "3");
                }
                // else if (
                //   res.data.responseModel.preAssessStatus == "TIMEOUT"
                // ) {
                //   jumpStep(14, "success", "13");
                // }
                else {
                  ccFormValue.value.ekyc.preStatus =
                    res.data.responseModel.preAssessStatus;
                  MasterService.finalSubmit(
                    requestModel2,
                    ccFormValue.value.token
                  )
                    .then((res) => {
                      // if (res.status == 200) {
                      page13Overlay.value = false;
                      ccFormValue.value.dropOffStep = 11;
                      jumpStep(14, "success", "13");
                      // } else {
                      //   termsSubmitFail.value = true;
                      // }
                    })
                    .catch((e) => {
                      if (e.response && e.response.data.code == "WB-401") {
                        // EndSession
                        isTimeOut.value = false;
                        isSessionEnd.value = true;
                      }
                      page13Overlay.value = false;
                      termsSubmitFail.value = true;
                      count.value += 1;
                    });
                }
              }
            })
            .catch((e) => {
              if (e.response && e.response.data.code == "WB-401") {
                // EndSession
                isTimeOut.value = false;
                isSessionEnd.value = true;
              }
              // ccFormValue.value.value.ekyc.preStatus = "Down"
              MasterService.finalSubmit(requestModel2, ccFormValue.value.token)
                .then((res) => {
                  // if (res.status == 200) {
                  page13Overlay.value = false;
                  ccFormValue.value.dropOffStep = 11;
                  jumpStep(14, "success", "13");
                  // } else {
                  //   termsSubmitFail.value = true;
                  // }
                })
                .catch((e) => {
                  if (e.response && e.response.data.code == "WB-401") {
                    // EndSession
                    isTimeOut.value = false;
                    isSessionEnd.value = true;
                  }
                  page13Overlay.value = false;
                  termsSubmitFail.value = true;
                  count.value += 1;
                });
              jumpStep(14, "success", "13");
              // jumpStep(14, "denied2", "3");
            });
        } else {
          MasterService.finalSubmit(requestModel2, ccFormValue.value.token)
            .then((res) => {
              // if (res.status == 200) {
              page13Overlay.value = false;
              ccFormValue.value.dropOffStep = 11;
              jumpStep(14, "success", "13");
              // } else {
              //   termsSubmitFail.value = true;
              // }
            })
            .catch((e) => {
              if (e.response && e.response.data.code == "WB-401") {
                // EndSession
                isTimeOut.value = false;
                isSessionEnd.value = true;
              }
              page13Overlay.value = false;
              termsSubmitFail.value = true;
              count.value += 1;
            });
        }
      } else {
        termsSubmitFail.value = true;
      }
    })
    .catch((e) => {
      if (e.response && e.response.data.code == "WB-401") {
        // EndSession
        isTimeOut.value = false;
        isSessionEnd.value = true;
      }
      page13Overlay.value = false;
      termsSubmitFail.value = true;
      count.value += 1;
    });
}
